import { apiAuthClient } from 'shared/api/lib/apiAuthClient';
import type {
  PostDocumentsQueueGroupsRequestType,
  PostDocumentsQueueGroupsResponseType,
} from '../types';

export const postDocumentsQueueGroups = async (
  params: PostDocumentsQueueGroupsRequestType,
) => {
  const url = `/api/v2/documents/${params.documentId}/queue/groups`;
  const response =
    await apiAuthClient.post<PostDocumentsQueueGroupsResponseType>(url, {
      groups: params.groups,
    });

  return response.data;
};
